import {
	IonButton,
	IonButtons,
	IonFooter,
	IonHeader,
	IonIcon,
	IonPage,
	IonText,
} from "@ionic/react";
import { useTranslation } from "react-i18next";
import Image_nl from "@/assets/app/explainer/nl/4@2x.png";
import { Button } from "@/components/Global/Button";
import { Content } from "@/components/Global/Content";
import { Toolbar } from "@/components/Global/Toolbar";
import { arrowLeftIcon } from "@/lib/icons/@heroicons/react/16/solid";
import { Routes } from "@/lib/router";
import { useSelectorModalStore } from "@/lib/store/modal";

export function CoreValuesSort() {
	const presentModal = useSelectorModalStore.use.present();
	const { t, i18n } = useTranslation();

	return (
		<IonPage>
			<IonHeader className="ion-no-border">
				<Toolbar className="ion-p-2 plt-desktop:sm:ion-px-[max(calc(calc(100vw-640px)/2),--spacing(4))]">
					<IonButtons slot="secondary" className="flex w-full justify-between">
						<IonButton
							data-attr="page.core-values.sort.back"
							data-touch-target
							routerLink={Routes.Dashboard()}
							routerDirection="back"
							color="light"
							className="part-icon:m-0 part-icon:size-5 part-native:size-10 part-native:min-h-0 part-native:rounded-full part-native:bg-brown-300 part-native:p-1 part-native:text-xs part-native:text-brown-600 min-h-0"
						>
							<IonIcon icon={arrowLeftIcon} />
						</IonButton>
					</IonButtons>
				</Toolbar>
			</IonHeader>
			<Content scrollY={false}>
				<img
					src={{ nl: Image_nl }[i18n.language]}
					className="mx-auto h-full max-h-[60vmax] w-full max-w-[60vmax] object-cover"
				/>
				<div className="flex flex-col gap-1">
					<IonText className="text-brown-700 text-3xl font-bold">
						{t("core-values.sort.title")}
					</IonText>
					<IonText className="text-brown-600 text-md text-pretty">
						{t("core-values.sort.description")
							.split("\n")
							.map((line, i) => (
								<>
									{i > 0 && (
										<>
											<br />
											<br />
										</>
									)}
									{line}
								</>
							))}
					</IonText>
				</div>
			</Content>
			<IonFooter>
				<div className="plt-desktop:sm:px-[max(calc(calc(100vw-640px)/2),--spacing(4))] p-4">
					<Button
						data-attr="page.app.friend-check.empty.action"
						expand="block"
						className="w-full"
						variant="primary"
						onClick={() => {
							presentModal("coreValuesCompileExplainer", {
								onCompleted: () => {
									presentModal("coreValuesCompileGeneral");
								},
							});
						}}
					>
						{t("core-values.sort.action")}
					</Button>
				</div>
			</IonFooter>
		</IonPage>
	);
}
